var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMikevoiceicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 19,
    viewBox: "0 0 12 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 15.125C8.51142 15.125 10.75 12.8864 10.75 10.125V8.875M5.75 15.125C2.98858 15.125 0.75 12.8864 0.75 10.125V8.875M5.75 15.125V18.25M2.625 18.25H8.875M5.75 12.625C4.36929 12.625 3.25 11.5057 3.25 10.125V3.25C3.25 1.86929 4.36929 0.75 5.75 0.75C7.13071 0.75 8.25 1.86929 8.25 3.25V10.125C8.25 11.5057 7.13071 12.625 5.75 12.625Z",
    stroke: "#606060",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMikevoiceicon);
export default __webpack_public_path__ + "static/media/mikevoiceicon.9aeed6b3a4d3e608611427dcee95a8c4.svg";
export { ForwardRef as ReactComponent };